import ServiceList from '../../views/Service/ServiceList';
import ServiceTypeList from '../../views/Service/ServiceTypeList';
import ServiceEdit from '../../views/Service/ServiceEdit';
import ServiceSearch from '../../views/Service/components/ServiceSearch';

export default [
    {
        path: '/servicos',
        name: 'service.list',
        component: ServiceList,
        meta: {
            pageTitle: 'Serviços',
            searchBar: ServiceSearch,
            breadcrumb: [
                { label: 'Serviços' },
            ],
        },
    },
    {
        path: '/servicos/tipos',
        name: 'service-type.list',
        component: ServiceTypeList,
        meta: {
            pageTitle: 'Serviços',
            breadcrumb: [
                { label: 'Serviços' },
            ],
        },
    },
    {
        path: '/servicos/cadastro',
        name: 'service.create',
        component: ServiceEdit,
        meta: {
            pageTitle: 'Cadastro de Serviço',
            breadcrumb: [
                { label: 'Serviços', routeName: 'service.list' },
                { label: 'Cadastro de Serviço' },
            ],
        },
    },
    {
        path: '/servicos/:id',
        name: 'service.edit',
        component: ServiceEdit,
        meta: {
            pageTitle: 'Edição de Serviço',
            breadcrumb: [
                { label: 'Serviços', routeName: 'service.list' },
                { label: 'Edição de Serviço' },
            ],
        },
    },

    {
        path: '/cliente/servicos',
        name: 'customer-service.list',
        component: ServiceList,
        meta: {
            pageTitle: 'Serviços',
            searchBar: ServiceSearch,
            breadcrumb: [
                { label: 'Serviços' },
            ],
        },
    },
    {
        path: '/cliente/servicos/tipos',
        name: 'customer-service-type.list',
        component: ServiceTypeList,
        meta: {
            pageTitle: 'Serviços',
            breadcrumb: [
                { label: 'Serviços' },
            ],
        },
    },
    {
        path: '/cliente/servicos/cadastro',
        name: 'customer-service.create',
        component: ServiceEdit,
        meta: {
            pageTitle: 'Cadastro de Serviço',
            breadcrumb: [
                { label: 'Serviços', routeName: 'customer-service.list' },
                { label: 'Cadastro de Serviço' },
            ],
        },
    },
    {
        path: '/cliente/servicos/:id',
        name: 'customer-service.edit',
        component: ServiceEdit,
        meta: {
            pageTitle: 'Edição de Serviço',
            breadcrumb: [
                { label: 'Serviços', routeName: 'customer-service.list' },
                { label: 'Edição de Serviço' },
            ],
        },
    },
];
